import { AC_GROUPS, AC_TYPES } from '../AC.types.constant';
import { CriterionType } from '../../../types/screener.type';

const managementEffectivenessAC: CriterionType[] = [
  {
    id: 'MGMT-10',
    label: 'Return on equity (ROE) (%)',
    shortLabel: 'ROE',
    unit: '%',
    group: AC_GROUPS.managementEffectiveness,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'MGMT-20',
    label: 'Return on assets (ROA) (%)',
    shortLabel: 'ROA',
    unit: '%',
    group: AC_GROUPS.managementEffectiveness,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'MGMT-30',
    label: 'Return on investment (ROI) (%)',
    shortLabel: 'ROI',
    unit: '%',
    group: AC_GROUPS.managementEffectiveness,
    type: AC_TYPES.normal,
    withRange: true,
  },
];

export default managementEffectivenessAC;
